import { render, staticRenderFns } from "./PayPalCreditCard.vue?vue&type=template&id=6a95dd80"
import script from "./PayPalCreditCard.vue?vue&type=script&lang=ts"
export * from "./PayPalCreditCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports